/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RelationshipType } from './RelationshipType';
import {
    RelationshipTypeFromJSON,
    RelationshipTypeFromJSONTyped,
    RelationshipTypeToJSON,
    RelationshipTypeToJSONTyped,
} from './RelationshipType';

/**
 * The header and text of the referral link text on the signup page.
 * @export
 * @interface ReferralLinkText
 */
export interface ReferralLinkText {
    /**
     * 
     * @type {string}
     * @memberof ReferralLinkText
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ReferralLinkText
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralLinkText
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof ReferralLinkText
     */
    header?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralLinkText
     */
    description?: string;
    /**
     * 
     * @type {RelationshipType}
     * @memberof ReferralLinkText
     */
    relationshipType: RelationshipType;
}



/**
 * Check if a given object implements the ReferralLinkText interface.
 */
export function instanceOfReferralLinkText(value: object): value is ReferralLinkText {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('relationshipType' in value) || value['relationshipType'] === undefined) return false;
    return true;
}

export function ReferralLinkTextFromJSON(json: any): ReferralLinkText {
    return ReferralLinkTextFromJSONTyped(json, false);
}

export function ReferralLinkTextFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralLinkText {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'header': json['header'] == null ? undefined : json['header'],
        'description': json['description'] == null ? undefined : json['description'],
        'relationshipType': RelationshipTypeFromJSON(json['relationshipType']),
    };
}

export function ReferralLinkTextToJSON(json: any): ReferralLinkText {
    return ReferralLinkTextToJSONTyped(json, false);
}

export function ReferralLinkTextToJSONTyped(value?: ReferralLinkText | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'header': value['header'],
        'description': value['description'],
        'relationshipType': RelationshipTypeToJSON(value['relationshipType']),
    };
}

